import { render, staticRenderFns } from "./AnswersRow.vue?vue&type=template&id=1d3f2060&scoped=true"
import script from "./AnswersRow.vue?vue&type=script&lang=js"
export * from "./AnswersRow.vue?vue&type=script&lang=js"
import style0 from "./AnswersRow.vue?vue&type=style&index=0&id=1d3f2060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f2060",
  null
  
)

export default component.exports